import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import IProfile from 'types/profile/IProfile';
import IProfileUpdateLanguage from 'types/profile/IProfileUpdateLanguage';
import IChangePassword from 'types/profile/IProfileUpdatePassword';
import ISetPasswordRequest from 'types/profile/ISetPasswordRequest';
import IForgotPasswordRequest from 'types/profile/IForgotPasswordRequest';
import IKioskPinState from 'types/profile/IKioskPinState';

export const getProfileRequest = async (): Promise<IProfile> => {
  const response: AxiosResponse<IProfile> = await getApi().get('/Profile');
  return response.data;
};

export const changePasswordRequest = async (data: IChangePassword): Promise<boolean> => {
  const response = await getApi().put('/Profile/ChangePassword', data);
  if (response.status === 200) {
    return true;
  }
  return false;
};
export const updateLanguageRequest = async (data: IProfileUpdateLanguage): Promise<void> => {
  await getApi().put('/Profile/ChangeLanguage', data);
};

export const setPasswordRequest = async (data: ISetPasswordRequest): Promise<void> => {
  await getApi().put('/Profile/SetPassword', data);
};

export const forgotPasswordRequest = async (data: IForgotPasswordRequest): Promise<void> => {
  await getApi().put('/Profile/ResetPassword', data);
};

export const getStatuteTooltipUrlRequest = async (): Promise<string> => {
  const response: AxiosResponse<string> = await getApi().get('/Profile/StatuteTooltipUrl');
  return response.data;
};

/** 403 → caller has no employee membership; callers should render nothing. */
export const getKioskPinStateRequest = async (): Promise<IKioskPinState> => {
  const response: AxiosResponse<IKioskPinState> = await getApi().get('KioskPin');
  return response.data;
};

/** Set-or-change: `rowVersion` must be the value from the last state fetch (null when no PIN exists yet). */
export const setKioskPinRequest = async (pin: string, rowVersion: string | null): Promise<IKioskPinState> => {
  const response: AxiosResponse<IKioskPinState> = await getApi().put('KioskPin', {
    pin,
    rowVersion,
    surface: 'Web',
  });
  return response.data;
};

/** Reveal the plaintext PIN behind the account-password proof. 401 on a wrong password. */
export const revealKioskPinRequest = async (password: string): Promise<string> => {
  const response: AxiosResponse<{ pin: string }> = await getApi().post('KioskPin/Reveal', {
    proofType: 'Password',
    password,
    surface: 'Web',
  });
  return response.data.pin;
};
